import {persistLeadParamsFromLocation} from "./lead/lead-params.storage";
import {initMetaPixel} from "./meta/meta-pixel";

persistLeadParamsFromLocation();

initMetaPixel({
    pixelId: "911922857908936",
    trackPageView: true,
});
